import { Card, CardContent, CardHeader, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Stack, Switch } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import { ArrowBack } from "@mui/icons-material"
import MaterialTypography from "../../../components/MaterialTypography"
import { useNavigate, useSearchParams } from "react-router-dom"
import MaterialBox from "../../../components/MaterialBox"
import MaterialInput from "../../../components/MaterialInput"
import { useFinancerFormHandling } from "./components/FinancerStateHandle"
import MaterialButton from "../../../components/MaterialButton"
import { useEffect, useState } from "react"
import { fetchDataById, postData, putData } from "../../../services"
import { useSnackbar } from "../../../context/popup"

const FinancerForm = () => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const financerId = searchParams.get("id");
    const pageType = searchParams.get("pageType");
    const pageMode = pageType === "view" ? "view" : pageType === "edit" 
      ? "edit" : "add";
    const { formData,setFormData, handleChange, checkAllFields } = useFinancerFormHandling();
    const { showSnackbar } = useSnackbar();

    useEffect(() => {
        if (pageMode === "add" || !financerId) {
            return;
        }

        //Fetch data by Pincode Id
        const fetchFinancerById = async (financerId) => {
            try {
            const response = await fetchDataById(`/reference/general/financer-list-master/${financerId}`);

            const responseData = response?.data?.financer;
            
            if (response.success) {
                const mapped = {
                    name: responseData?.name || "",
                    iplFinancerId: responseData?.id || "",
                    sortOrder: responseData?.sortOrder || 0,
                    active: responseData?.isActive,
                    // reset status fields
                    nameStatus: responseData?.name ? "success" : "unchecked",
                    iplFinancerIdStatus: responseData?.id ? "success" : "unchecked",

                };

                setFormData(mapped);   //view data
            }
            } catch (error) {
            console.error("Error fetching data by ID:", error);
            showSnackbar(error?.response?.data?.message || "Error fetching data by ID", "error");
            }
        };

        fetchFinancerById(financerId);
    }, [pageMode]);

    const handleSubmitFinancer = async () => {
        try {
            if(pageMode === "edit"){
                const financerPutData = {
                    name: formData?.name,    
                    sortOrder: Number(formData?.sortOrder),      
                    isActive: formData.active
                }
                const response = await putData(`/reference/general/financer-list-master/${financerId}`, financerPutData);
                const successResponse = response?.success;
                const responseMessage = response?.message;
                if(successResponse){
                    showSnackbar(responseMessage,"success");
                    navigate("/general-master/financer-list");
                }
                else{
                    showSnackbar(responseMessage)
                }
            }
            else if(pageMode === "add"){
                const financerPostData = {
                    name: formData?.name,  
                    sortOrder: Number(formData.sortOrder),        
                    isActive: formData.active
                }
                const response = await postData("/reference/general/financer-list-master", financerPostData);
    
                if (response?.success) {
                    showSnackbar(response?.message, "success");
                    setTimeout(() => {
                        navigate("/general-master/financer-list");
                    }, 1000);
                }
            }

        } catch (error) {
            console.error("Error Posting data:", error);
            showSnackbar(error?.response?.data?.message || "Error Posting data", "error");
        }
    }

  return (
    <DashboardLayout>
        <Card sx={{ minHeight: 500 }}>
            <CardHeader
                title={(
                    <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                    >
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <IconButton onClick={() => navigate("/general-master/financer-list")}>
                                <ArrowBack />
                            </IconButton>
                            <Stack direction="column" spacing={0}>
                                <MaterialTypography variant="h5" fontWeight="medium">
                                    Financer Details
                                </MaterialTypography>
                                <MaterialTypography variant="caption" color="text">
                                    Enter New Financer Details.
                                </MaterialTypography>
                            </Stack>
                        </Stack>
                    </Stack>
                )}
            />
            <CardContent>
                <Grid2 container spacing={1}>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Financer Name*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        success={formData.nameStatus === "success"}
                        error={formData.nameStatus === "error"}
                        disabled={pageMode === "view"}
                        />
                        {formData.nameStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                Financer Name should be at least 1 character and at most 100 characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Sort Order
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        type="number"
                        name="sortOrder"
                        value={formData.sortOrder}
                        onChange={handleChange}
                        success={formData.sortOrderStatus === "success"}
                        error={formData.sortOrderStatus === "error"}
                        disabled={pageMode === "view"}
                        inputProps={{ min: 0 }}
                        />
                        {formData.sortOrderStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                Enter valid Sorting Order between (0-10000).
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>
                    {(pageMode === "view" || pageMode === "edit") && (
                        <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                            <MaterialBox>
                                <MaterialTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold">
                                    IPL Financer ID
                                </MaterialTypography>
                            </MaterialBox>
                            <MaterialInput
                            name="iplFinancerId"
                            value={formData.iplFinancerId}
                            onChange={handleChange}
                            success={formData.iplFinancerIdStatus === "success"}
                            error={formData.iplFinancerIdStatus === "error"}
                            disabled
                            />
                        </Grid2>
                    )}
                    <Grid2 size={{lg:2, md:2, sm: 2, xs: 2 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Actve
                            </MaterialTypography>
                        </MaterialBox>
                        <FormControlLabel
                        control={
                            <Switch
                                checked={formData.active}
                                disabled={pageMode === "view"}
                                onChange={(e) =>
                                    handleChange({
                                        target: {
                                            name: "active",
                                            value: e.target.checked,
                                        },
                                    })
                                }
                                color="primary"
                            />
                        }
                        label={
                            <MaterialTypography variant="caption" fontWeight="bold">
                                {formData?.active ? "Yes" : "No"}
                            </MaterialTypography>
                        }
                        sx={{ marginLeft: 0 }}
                        />
                    </Grid2>
                </Grid2>
            </CardContent>
            <MaterialBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
            {pageMode === "add" && (
            <>
                <MaterialButton
                sx={{ m: 2 }}
                variant="outlined"
                color="dark"
                onClick={() => navigate("/general-master/financer-list")}
                >
                Cancel
                </MaterialButton>
                <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={handleSubmitFinancer}
                >
                Submit
                </MaterialButton>
            </>
            )}
    
            {pageMode==="edit" && (
            <>
            <MaterialButton
            variant="outlined"
            color="dark"
            sx={{ m: 2 }}
            oonClick={() => navigate("/general-master/financer-list")}
            >
            Cancel
            </MaterialButton>
            <MaterialButton
            sx={{ m: 2 }}
            variant="gradient"
            color="dark"
            disabled={!checkAllFields()}
            onClick={handleSubmitFinancer}
            >
            Update
            </MaterialButton>
            </>
            )}
            </MaterialBox>
        </Card>
    </DashboardLayout>
  )
}

export default FinancerForm